export const sampleVast = `<?xml version="1.0" encoding="UTF-8"?>
<VAST version="3.0">
  <Ad id="1">
    <InLine>
      <Creatives>
        <Creative>
          <Linear>
            <Duration>00:00:10</Duration>
            <MediaFiles>
              <MediaFile delivery="progressive" type="video/mp4">https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4</MediaFile>
              <MediaFile type="image/jpeg">https://upload.wikimedia.org/wikipedia/commons/3/3f/JPEG_example_flower.jpg</MediaFile>
            </MediaFiles>
            <VideoClicks>
              <ClickThrough><![CDATA[https://example.com]]></ClickThrough>
            </VideoClicks>
          </Linear>
        </Creative>
      </Creatives>
      <Impression><![CDATA[https://example.com/imp]]></Impression>
    </InLine>
  </Ad>
</VAST>`
